import { DATE_FORMAT, TIME_FORMAT, DATETIME_FORMAT } from './dateFormats';

// Reference date with unambiguous values: Jan 15 avoids month/day swaps in en-US vs fr-FR.
// 13:45 gives a clear hour value that distinguishes 12h from 24h formatting.
const REFERENCE_DATE = new Date(2026, 0, 15, 13, 45);

const intlPartToDateFns = (type: string, is12h: boolean): string => {
  switch (type) {
    case 'day': return 'dd';
    case 'month': return 'MM';
    case 'year': return 'yy';
    case 'hour': return is12h ? 'h' : 'HH';
    case 'minute': return 'mm';
    case 'dayPeriod': return 'aa';
    default: return '';
  }
};

const escapeLiteral = (value: string): string => `'${value}'`;

const buildFormatFromParts = (parts: Intl.DateTimeFormatPart[], is12h: boolean): string =>
  parts.map(part => {
    if (part.type === 'literal') {
      return escapeLiteral(part.value);
    }
    return intlPartToDateFns(part.type, is12h);
  }).join('');

export const getDatePickerFormat = (locale: string): string => {
  const parts = new Intl.DateTimeFormat(locale, DATE_FORMAT).formatToParts(REFERENCE_DATE);
  return buildFormatFromParts(parts, false);
};

export const getTimePickerFormat = (locale: string): string => {
  const parts = new Intl.DateTimeFormat(locale, TIME_FORMAT).formatToParts(REFERENCE_DATE);
  const is12h = parts.some(part => part.type === 'dayPeriod');
  return buildFormatFromParts(parts, is12h);
};

export const getDateTimePickerFormat = (locale: string): string => {
  const parts = new Intl.DateTimeFormat(locale, DATETIME_FORMAT).formatToParts(REFERENCE_DATE);
  const is12h = parts.some(part => part.type === 'dayPeriod');
  return buildFormatFromParts(parts, is12h);
};
